export default function TdsField({
  label,
  required,
  error,
  children,
  className = "",
}) {
  return (
    <div className={`tds-field ${error ? "tds-field--error" : ""} ${className}`.trim()}>
      {label ? (
        <label>
          {label}
          {required ? <span className="req">*</span> : null}
        </label>
      ) : null}
      {children}
      {error ? <span className="tds-field-error">{error}</span> : null}
    </div>
  );
}
